(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecocut-simple-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-ec-request]')) return;
  const quantity = event.target.form?.querySelector('[data-ec-quantity]');
  if (quantity) quantity.min = event.target.selectedOptions[0]?.dataset.minimum || '1';
});
  } catch(e) { console.error(e); }
})();

})();
